import { apiService } from 'adapters/apiService';
import { HeaderData } from 'adapters/types';
import { CashInBankAccountsType } from 'components/CashInBankAccountsDropdown/types';
import {
  CashInBankResponseType,
  ErrorResponse,
  GlValidationResponseType
} from 'pages/AuthorizePaymentPage/interCompany/types';
import { METHOD, PATHS } from '../constants';
import type { AuthorizePaymentReviewType } from 'pages/AuthorizePaymentPage/types';
import type { AuthorizationPaymentResponse } from 'pages/VendorPaymentResultPage/types';

export const postAuthorizedPayment = async (
  reqObj: AuthorizePaymentReviewType,
  headers: HeaderData,
  storeId: string
): Promise<AuthorizationPaymentResponse> => {
  const response = await apiService({
    url: PATHS.getAuthorizeVccPay(),
    method: METHOD.POST,
    reqObj,
    headers: { ...headers, 'x-store-id': storeId }
  });
  if (!response.ok) throw new Error(response.statusText);
  return response.json() as Promise<AuthorizationPaymentResponse>;
};

export const glPostingValidation = async (
  reqObj: AuthorizePaymentReviewType,
  headers: HeaderData,
  storeId: string
): Promise<GlValidationResponseType> => {
  const response = await apiService({
    url: PATHS.getGlPostingValidation(),
    method: METHOD.POST,
    reqObj,
    headers: { ...headers, 'x-store-id': storeId }
  });
  if (!response.ok) throw new Error(response.statusText);
  return response.json() as Promise<GlValidationResponseType>;
};

export const fetchCashInBankAccounts = async (
  headers: HeaderData,
  storeId: string,
  companyId: string
): Promise<CashInBankAccountsType> => {
  const response = await apiService({
    url: PATHS.getCashInBankAccountsPath(companyId),
    method: METHOD.GET,
    headers: { ...headers, 'x-store-id': storeId }
  });
  if (!response?.ok) throw new Error(response.statusText);
  return response.json() as Promise<CashInBankAccountsType>;
};

export const fetchCashInBankInterCompany = async (
  headers: HeaderData,
  storeId: string,
  printerInfo: boolean
): Promise<CashInBankResponseType | ErrorResponse> => {
  const response = await apiService({
    url: PATHS.getCashInBankAccounts(storeId, printerInfo),
    method: METHOD.GET,
    headers: { ...headers, 'x-store-id': storeId }
  });
  if (!response?.ok) throw new Error(response.statusText);
  return response.json() as Promise<CashInBankResponseType | ErrorResponse>;
};
